module.exports = __webpack_public_path__ + "static/media/faq.46f747f5.jpg";